export const filtersMap = {
  startDate: 'startDate',
  endDate: 'endDate',
  statusFilter: 'statusFilter',
  page: 'page',
  limit: 'limit',
} as const;
